import React from 'react';
import { DialogTitle } from '../../../components/Dialog/NewNote';
import { Grid, TextareaAutosize, Dialog, DialogContent, Divider } from '@material-ui/core';
import Tooltip from "@material-ui/core/Tooltip";
import Table from '../../../components/Table/Table';
import { Card } from "../../../styles";
import styled from "styled-components";
import { InfoIconOutline as InfoIcon } from "./Icons";
import { backgroundColor } from 'styled-system';
import { makeStyles } from "@material-ui/core/styles";


const Label = styled.p`  
  color:#9FA2B4;
  font-size:12px;
  font-weight:600;
  margin-bottom:0;
  padding: 10px 25px 0px 25px;
`
const StyledEmptyContainer = styled.div`
  display: flex;
  height: 300px;
  justify-content: center;
  align-items: center;
`;

const LabelValue = styled.p`  
  color:#000000;
  font-size:14px;
  font-weight:400;
  margin-bottom:0;
  padding: 0 25px 0px 25px;
`

const useStyles = makeStyles(() => ({
    tooltip: {
      backgroundColor: "#525252",   
      color: "#FFFFFF",             
      fontSize: "12px",
      padding: "6px 10px",
      borderRadius: "4px",
    },
    arrow: {
      color: "#525252", 
    },
  }));
function ReferringPhysiciansModal({ open, onClose, data }) {
    const classes = useStyles();
    return (
      <Dialog
        open={open}
        maxWidth="sm"
        fullWidth
        onClose={onClose}
      >
 <style>
      {`
        .MuiTooltip-tooltip {
          background-color: #525252 !important;
          color: white !important;
          font-size: 12px !important;
          padding: 6px 10px !important;
          border-radius: 4px !important;
        }

        .MuiTooltip-arrow {
          color: #525252 !important;
        }
      `}
      </style>
        <DialogTitle id="customized-dialog-title" onClose={onClose}>
          <p style={{ fontSize: "24px", fontWeight: "bold", margin: 0 }}>
            Referring Physicians
          </p>
        </DialogTitle>
          <Label>Sent to fax number </Label>
                     <LabelValue>
                     {data.fax ? data.fax : 'N/A'}
                     </LabelValue>
  
        <DialogContent style={{ minHeight: "150px", paddingBottom: "24px" }}>
            <Card>
        {data?.referring_physicians?.length > 0 ? (
          <Table
            rows={data?.referring_physicians}
            columns={[
                { key: "unique_id", name: "Unique ID",align: "left" },
                { key: "name", name: "Name",align: "left" },
                {
                    key: "fax",
                    name: "Fax",
                    align: "left",
                    displayCell: (col, cellValue, row) => {

                      const isDifferent = cellValue.fax !== data.fax;
  
                      return (
                        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                          <span
                            style={{
                              color: isDifferent ? "#9FA2B4" : "#000", 
                              fontWeight: isDifferent ? "600" : "400",
                            }}
                          >
                            {col}
                          </span>
  
                          {isDifferent && (
                           <Tooltip
                           title="Fax number updated"
                           arrow
                           disablePortal
                           classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
                         >
                           <div>
                             <InfoIcon />
                           </div>
                         </Tooltip>
                          )}
                        </div>
                      );
                    },
                 }
                ]}
            clickHandler={() => null}
            shouldGetRowActions={false}
            noDataRender={() => <p>No referring physicians</p>}
          />
        ) : (
          <StyledEmptyContainer>
            <span>No referring physicians</span>
          </StyledEmptyContainer>
        )}
        </Card>
        </DialogContent>
      </Dialog>
    );
  }
  
  export default ReferringPhysiciansModal;
